module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 8
// module chunks = 0